<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div>
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="containerBackground"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['containerBackground']"
                @change="handleChangeContainerBackground"
              />
              <v-text-field v-model="fields['containerBackground']" label="Background Color" />
            </div>
          </div>
        </div>
        <div>
          <label style="font-weight: bold">Style Tab Header</label>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="headerColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['headerColor']"
                  @change="handleChangeHeaderColor"
                />
                <v-text-field v-model="fields['headerColor']" label="Header Color" />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div>
                <v-select
                  v-model="fields['headerPosition']"
                  :items="['left', 'center', 'right']"
                  label="Header Position"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center">
            <div>
              <label style="margin-bottom: 10px; font-weight: bold">List Tab</label>
            </div>
            <v-btn small text color="primary" @click="handleAddTab">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Tab</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['listTab']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Tab {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveTab(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-text-field v-model="item.title" label="Title" />
                  <div>
                    <label>Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'tabs-base-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        containerBackground: '',
        headerColor: '',
        headerPosition: '',
        listTab: [],
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTabs(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeContainerBackground(event) {
      this.fields['containerBackground'] = event.target.value;
    },
    handleChangeHeaderColor(event) {
      this.fields['headerColor'] = event.target.value;
    },
    handleAddTab() {
      this.fields['listTab'].push({
        title: 'Lorem ipsum',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
      });
    },
    handleRemoveTab(index) {
      this.fields['listTab'].splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
